import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: 'compliance-rules',
    pathMatch: 'prefix',
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        m => m.DashboardModule
      ),
  },
  {
    path: 'compliance-performance',
    pathMatch: 'prefix',
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        m => m.DashboardModule
      ),
  }, // compliance-performance
  /* {
    path: 'staff-management',
    pathMatch: 'prefix',
    loadChildren: () =>
      import('./modules/staff-account-management/staff-account-management.module').then(
        m => m.StaffAccountManagementModule
      ),
  }, */
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EnterpriseManagementRoutingModule {}
